import {
  INORA_PRODUCTION_HOSTNAMES,
  INORA_PRODUCTION_ORIGINS,
  isInoraProductionHostname,
} from "@/lib/platform/production-hosts";

/** Production hosts where browser RUM is allowed to initialize and send data. */
export const DATADOG_PRODUCTION_HOSTNAMES = INORA_PRODUCTION_HOSTNAMES;
export const DATADOG_PRODUCTION_ORIGINS = INORA_PRODUCTION_ORIGINS;

export const DATADOG_APPLICATION_ID =
  process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID?.trim() ||
  "f5c80b05-56ed-422e-ad2a-7772f56f964a";

export const DATADOG_CLIENT_TOKEN =
  process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN?.trim() ||
  "pub8212161fb719a8f2002edb64809b8572";

export const DATADOG_SITE =
  process.env.NEXT_PUBLIC_DATADOG_SITE?.trim() || "us5.datadoghq.com";

export const DATADOG_SERVICE =
  process.env.NEXT_PUBLIC_DATADOG_SERVICE?.trim() || "inora";

export const DATADOG_VERSION =
  process.env.NEXT_PUBLIC_DATADOG_VERSION?.trim() || "1.0.0";

export function isDatadogProductionHostname(hostname: string): boolean {
  return isInoraProductionHostname(hostname);
}

/** Never load or send RUM in local dev / NODE_ENV=development. */
export function isDatadogDevEnvironment(): boolean {
  return process.env.NODE_ENV === "development";
}

/**
 * Client-only: production hostname on a non-development build.
 * Safe to call from instrumentation-client (browser bundle).
 */
export function isDatadogRumEnabled(): boolean {
  if (isDatadogDevEnvironment()) return false;
  if (typeof window === "undefined") return false;
  return isDatadogProductionHostname(window.location.hostname);
}
